export const filters = {
  truncate(text: string, length: number): string {
    if (text && text.length > length) {
      return text.substring(0, length) + "...";
    } else {
      return text;
    }
  },
};

export type Typefilter = typeof filters;
